import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sessions: [],
  currentSession: null,
  messages: [],
  activeViewers: [],
  loading: false
};

const liveSessionSlice = createSlice({
  name: 'liveSession',
  initialState,
  reducers: {
    setSessions: (state, action) => {
      state.sessions = action.payload;
    },
    setCurrentSession: (state, action) => {
      state.currentSession = action.payload;
    },
    setMessages: (state, action) => {
      state.messages = action.payload;
    },
    addMessage: (state, action) => {
      state.messages.push(action.payload);
    },
    setActiveViewers: (state, action) => {
      state.activeViewers = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    }
  }
});

export const { setSessions, setCurrentSession, setMessages, addMessage, setActiveViewers, setLoading } = liveSessionSlice.actions;
export default liveSessionSlice.reducer;
